function removeChildArray(data) {
  const _data = {};
  Object.keys(data).forEach((key) => {
    if(Array.isArray(data[key])) return;

    _data[key] = data[key];
  })

  return _data;
}

module.exports = {
  removeChildArray
}